import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageSquareReply } from "lucide-react";
import { Link } from "react-router-dom";
import { api, messageErreur } from "@/lib/api";

const RETOURS = [["signe", "Signé"], ["perdu", "Perdu"], ["mauvais_lead", "Mauvais lead"]];

export const RetourPartenaire = ({ fiche, onMaj }) => {
  const [commentaire, setCommentaire] = useState("");
  const actuel = fiche.retour_partenaire;
  const envoyer = async (retour) => {
    try { await api.post(`/fiches/${fiche.id}/retour-partenaire`, { retour, commentaire }); toast.success("Retour transmis à l'agent."); setCommentaire(""); onMaj(); }
    catch (x) { toast.error(messageErreur(x)); }
  };
  return (
    <section className="at-card p-5 space-y-3" data-testid="partner-feedback-card">
      <p className="font-bold flex items-center gap-2"><MessageSquareReply size={16} />Votre retour sur ce lead</p>
      {actuel && <p className="text-sm" data-testid="partner-feedback-current">Retour actuel : <b>{actuel.label}</b>{actuel.commentaire ? ` · ${actuel.commentaire}` : ""}</p>}
      <input value={commentaire} onChange={(e) => setCommentaire(e.target.value)} placeholder="Commentaire pour l'agent (facultatif)" className="at-input" data-testid="partner-feedback-comment" />
      <div className="grid grid-cols-3 gap-2">
        {RETOURS.map(([c, l]) => <button key={c} type="button" onClick={() => envoyer(c)} className={`at-btn ${actuel?.retour === c ? "at-btn-primary" : "at-btn-ghost"} !px-2 text-sm`} data-testid={`partner-feedback-${c}`}>{l}</button>)}
      </div>
    </section>
  );
};

export const MesRetours = () => {
  const [l, setL] = useState([]);
  useEffect(() => { api.get("/tableaux/retours").then((r) => setL(r.data)); }, []);
  if (!l.length) return null;
  return (
    <section className="at-carte space-y-2" data-testid="agent-partner-feedback">
      <p className="font-bold">Retours des partenaires sur vos leads</p>
      {l.slice(0, 6).map((r) => (
        <Link key={r.fiche_id} to={`/fiches/${r.fiche_id}`} className="flex justify-between gap-2 min-h-[44px] items-center text-sm" data-testid={`agent-feedback-${r.fiche_id}`}>
          <span className="min-w-0 truncate"><b>{r.nom}</b> · {r.partenaire}{r.commentaire ? ` · ${r.commentaire}` : ""}</span>
          <span className="text-xs font-bold shrink-0" style={{ color: r.retour === "signe" ? "var(--success)" : "var(--danger)" }}>{r.label}</span>
        </Link>
      ))}
    </section>
  );
};
